import {Box, Typography} from '@mui/material'
import PropTypes from 'prop-types'

import Button from '../../../../shared_components/mui_base_components/button/Button'
import routerUtils from '../../../../lib/routerUtils'

import sharingImage from '../../../../dashboard/assets/sharing-module.svg'

import './sharingModuleWithoutDeputies.scss'

const SharingModuleWithoutDeputies = ({context}) => {
  const handleClickInvite = () => {
    routerUtils.push(`cm/deputies?context=${context}`)
  }

  return (
    <Box className='sharing-module-without-deputies'>
      <img alt='' src={sharingImage} />
      <Typography className='heading' variant='h3'>
        Share your plan with the ones who’ll need it most
      </Typography>
      <Typography className='body-text'>
        At Everplans, we call these trusted contacts “Deputies.” They'll only
        see what you choose to share with them.
      </Typography>
      <Button className='invite' onClick={handleClickInvite}>
        Invite someone
      </Button>
    </Box>
  )
}

SharingModuleWithoutDeputies.propTypes = {
  context: PropTypes.string.isRequired
}

export default SharingModuleWithoutDeputies
